// src/components/PostCard/index.jsx
import React from 'react';
import { Card, Typography, Tag, Space, Button } from 'antd';
import { CalendarOutlined, UserOutlined, EyeOutlined, MessageOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './index.css';

const { Meta } = Card;
const { Title, Paragraph, Text } = Typography;

const PostCard = ({ post, showActions = true }) => {
  return (
    <Card
      className="post-card"
      cover={
        post.coverImage ? (
          <div className="post-cover">
            <img src={post.coverImage} alt={post.title} />
          </div>
        ) : null
      }
      actions={
        showActions
          ? [
              <Button type="text" icon={<EyeOutlined />}>{post.views || 0}</Button>,
              <Button type="text" icon={<MessageOutlined />}>{post.comments || 0}</Button>,
            ]
          : null
      }
    >
      <Meta
        title={
          <Link to={`/post/${post.id}`} className="post-title-link">
            <Title level={4} className="post-title">
              {post.title}
            </Title>
          </Link>
        }
        description={
          <>
            <Paragraph className="post-excerpt" ellipsis={{ rows: 3 }}>
              {post.excerpt || (post.content ? post.content.substring(0, 150) + '...' : '')}
            </Paragraph>
            
            <div className="post-meta">
              <Space size="middle">
                <Text className="post-author">
                  <UserOutlined /> {post.author?.name || post.author?.username || '匿名用户'}
                </Text>
                <Text className="post-date">
                  <CalendarOutlined /> {post.createdAt ? new Date(post.createdAt).toLocaleDateString() : ''}
                </Text>
              </Space>
              
              {post.category && (
                <Tag className="post-category">{post.category}</Tag>
              )}
            </div>
            
            {showActions && (
              <div className="post-readmore">
                <Link to={`/post/${post.id}`}>
                  <Button type="primary">阅读更多</Button>
                </Link>
              </div>
            )}
          </>
        }
      />
    </Card>
  );
};

export default PostCard;